
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Typography } from '@mui/material';
import { jsPDF } from 'jspdf';
import { Button, Col, Form, Dropdown, Row, Container } from "react-bootstrap";
import 'jspdf-autotable';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Box, Menu, MenuItem } from "@mui/material";
import { FiSearch } from 'react-icons/fi';


const ProjectReport = () => {
  const [ttowerno, setTowardsTowerNumber] = useState('');
  const [responset, setResponset] = useState([]);
  const [filterInput, setFilterInput] = useState('');
  const [prname, setPrName] = useState('');

  const [projectName, setProjectName] = useState([]);
  const [vPrname,setVPrname]=useState('');
  const [projectNameVilla, setProjectNameVilla] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const apiResponse1 = [
    { id: 'VillaNo', label: 'Villa No', width: 160, isVisible: true },
    { id: 'villasize', label: 'Villa Size', width: 170, isVisible: true },
    { id: 'villasqyard', label: 'Villa Sqyard', width: 0, isVisible: true },
    { id: 'facing', label: 'Facing', width: 0, isVisible: true },
    { id: 'totalValue', label: 'Total Value', width: 0, isVisible: true },
    { id: 'facingAmount', label: 'Facing Amount', width: 0, isVisible: true },
    { id: 'basePrice', label: 'Base Price', width: 0, isVisible: true },
    { id: 'advMaitanceAmt', label: 'Advance Maintenance Amount', width: 0, isVisible: true },
    { id: 'carpousAmt', label: 'Car Parking Amount', width: 0, isVisible: true },
    { id: 'cautionNonRefAmt', label: 'Caution Non Refundable Amount', width: 0, isVisible: true },
    { id: 'cautionRefAmt', label: 'Caution Refundable Amount', width: 0, isVisible: true },
    { id: 'clubHouseAmt', label: 'Clubhouse Amount', width: 0, isVisible: true },
    { id: 'waterElectricityAmt', label: 'Water Electricity Amount', width: 0, isVisible: true },
  ];

  const apiResponse2 = [
    { id: 'floor', label: 'Floor', width: 160, isVisible: true },
    { id: 'unit_name', label: 'Unit Name', width: 170, isVisible: true },
    // { id: 'status', label: 'Status', width: 0, isVisible: true },
    { id: 'unitsizeNum', label: 'Unit Size', width: 0, isVisible: true },
    { id: 'Facing', label: 'Facing', width: 0, isVisible: true },
    { id: 'cornor', label: 'Corner', width: 0, isVisible: true },
    { id: 'totalvalue', label: 'Total Value', width: 0, isVisible: true },
    { id: 'facingAmount', label: 'Facing Amount', width: 0, isVisible: true },
    { id: 'cornerAmount', label: 'Corner Amount', width: 0, isVisible: true },
    { id: 'BasePrice', label: 'Base Price', width: 0, isVisible: true },
    { id: 'advMaitanceAmt', label: 'Advance Maintenance Amount', width: 0, isVisible: true },
    { id: 'carpousAmt', label: 'Car Parking Amount', width: 0, isVisible: true },
    { id: 'cautionNonRefAmt', label: 'Caution Non Refundable Amount', width: 0, isVisible: true },
    { id: 'cautionRefAmt', label: 'Caution Refundable Amount', width: 0, isVisible: true },
    { id: 'clubHouseAmt', label: 'Clubhouse Amount', width: 0, isVisible: true },
    { id: 'waterElectricityAmt', label: 'Water Electricity Amount', width: 0, isVisible: true },
    { id: 'floorRiseAmount', label: 'Floor Rise Amount', width: 0, isVisible: true },
  ];

  const [viewMode, setViewMode] = useState('Full View');
  
  const [selectedColumnIds, setSelectedColumnIds] = useState(selectedColumns.filter(col => col.isVisible).map(col => col.id));

  useEffect(() => {
    const updatedColumns = selectedColumns.map(col => ({
      ...col,
      isVisible: viewMode === 'Full View' ? true : selectedColumnIds.includes(col.id)
    }));
    setSelectedColumns(updatedColumns);
  }, [viewMode, selectedColumnIds]);

  
  
  // useEffect(() => {
  //   getFloor();
  //   getProjectNames();
  // }, []);

  useEffect(()=>{
    getVillaProjectNames()
  },[])

  useEffect(() => {
    if (viewMode === 'Full View') {
      setSelectedColumns(prevColumns => prevColumns.map(col => ({ ...col, isVisible: true })));
    }
  }, [viewMode]);

  // const getFloor = () => {
  //   axios
  //     .post('https://buildfastapi.kollagroup.in/project/api/v1/towers-getall')
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setResponset(res.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching floor data:', error);
  //     });
  // };

  // const getProjectNames = () => {
  //   axios
  //     .get('https://buildfastapi.kollagroup.in/project/api/v1/get-basic')
  //     .then((res) => {
  //       setProjectName(res.data.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };


  const getVillaProjectNames = () => {
    axios
      .get('https://buildfastvapi.emedha.in/project/api/v1/get-basic')
      .then((res) => {
        setProjectNameVilla(res.data.data);
        console.log(res.data.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [villaPlots,setVillaPlots]=useState([])
   console.log(villaPlots)

  const getVillaPlots=()=>{
    axios.get('https://buildfastvapi.emedha.in/project/api/v1/get-villa-plots',{
      params:{projectName:vPrname}
    }).then((res)=>{
      setVillaPlots(res.data.data)
    })
  }

  useEffect(()=>{
    getVillaPlots()
  },[vPrname])



  useEffect(() => {
    if (villaPlots.length > 0) {
      // Check if the first element has "VillaNo" property
      if (villaPlots[0].hasOwnProperty('VillaNo')) {
        setSelectedColumns(apiResponse1); // Use apiResponse1 if VillaNo exists
      } else {
        setSelectedColumns(apiResponse2); // Otherwise, use apiResponse2
      }
    }
  }, [villaPlots]);


  // const fetchData = async () => {
  //   try {
  //     const response = await fetch(
  //       `https://buildfastapi.kollagroup.in/api/v1/api/project-details?ProjectName=${prname}&TowerNumber=${ttowerno}`
  //     );
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch data');
  //     }
  //     const data = await response.json();
  //     setFetchedData(data);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // useEffect(() => {
  //   if (ttowerno && prname) {
  //     fetchData();
  //   }
  // }, [ttowerno, prname]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
    });

    const columns = selectedColumns
      .filter(col => col.isVisible)
      .map((col) => ({
        header: col.label,
        dataKey: col.id,
        width: col.width,
      }));

    const rows = villaPlots.map((row) => {
      const filteredRow = {};
      selectedColumns.forEach((col) => {
        if (col.isVisible) {
          filteredRow[col.id] = row[col.id];
        }
      });
      return filteredRow;
    });

    doc.autoTable({
      columns,
      body: rows,
      margin: { top: 10, left: 10 },
      columnStyles: { 0: { cellWidth: 'auto' } },
    });

    doc.save('tablepdf.pdf');
  };

  const handleColumnToggle = (columnId) => {
    setSelectedColumns(prevColumns =>
      prevColumns.map(col =>
        col.id === columnId ? { ...col, isVisible: !col.isVisible } : col
      )
    );
  };

  const handleColumnSelection = (colId) => {
    setSelectedColumnIds(prev =>
      prev.includes(colId) ? prev.filter(id => id !== colId) : [...prev, colId]
    );
  };


  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    const userType = sessionStorage.getItem("userType");
    const projectNames = sessionStorage.getItem("ProjectName");

    // Filter projectNamesss based on userType and ProjectName
    const filtered = projectNameVilla.filter(project => {
      if (userType === "Admin") {
        return project.ProjectName === projectNames;
      }
      return true; // Show all projects for non-admins
    });

    setFilteredProjects(filtered);
  }, [projectNameVilla]);


  const companyId=sessionStorage.getItem("companyId");


  return (
    <>
      {/* <div className="card mt-2" style={{ border: 'none', paddingLeft: 15, paddingRight: 15, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div>
          <label style={{ fontSize: '13px', color: 'gray' }}>Search Filter</label>
          <br />
          <input
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            style={{ height: '2.3rem', color: 'gray', borderRadius: '0.3rem', outline: 'none', width: '20rem', border: '0.7px solid lightgray' }}
            placeholder="Search Details.."
          />
        </div>
        <div>
          <div className="d-flex flex-row align-items-center p-2 mt-3" style={{width:'280px'}}>

          <Form.Group as={Col} md="12" controlId="validationCustom01" className="mr-2 p-2">
              <Typography style={{ color: 'gray', fontSize: 13 }}>ProjectName</Typography>
              <Form.Select
                required
                onChange={(e) => setVPrname(e.target.value)}
                value={vPrname}
                type="text"
                style={{ padding: '0.42rem', marginBottom: 14 }}
              >
                <option>Select Project</option>
                {filteredProjects.filter((item=>item.company_id===parseInt(companyId))).map((item) => (
                  <option key={item.ProjectName} value={item.ProjectName}>
                    {item.ProjectName}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">Please Enter Valid Project Name</Form.Control.Feedback>
            </Form.Group>
         
            <Form.Group as={Col} md="8" controlId="viewMode">
              <Typography style={{ color: 'gray', fontSize: 13 }}>View Mode</Typography>
              <Form.Select
                onChange={(e) => setViewMode(e.target.value)}
                value={viewMode}
                style={{ padding: '0.42rem', marginBottom: 14 }}
              >
                <option value="Full View">Full View</option>
                <option value="Customized View">Customized View</option>
              </Form.Select>
            </Form.Group> 
          </div>
        </div>
      </div> */}

{/* Make sure to import { FiSearch } from "react-icons/fi" if not already imported */}
<Box sx={{ width: "100%" }}>
  
  {/* --- Centered Dashboard Header --- */}
  <Typography 
    sx={{ 
      color: "#1B2559", 
      fontSize: { xs: "24px", md: "28px" }, // Slightly smaller on mobile, larger on desktop
      fontWeight: "800", 
      textAlign: "center", // Centers the text perfectly
      letterSpacing: "-0.5px",
      mb: 3 // Margin bottom to give space before the filter box starts
    }}
  >
    Project Report
  </Typography>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Stacks vertically on mobile, horizontally on tablet/desktop
    alignItems: { xs: "stretch", md: "flex-end" }, // Aligns the bottoms of the inputs on desktop
    gap: "16px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
    mb: 3, // Margin bottom to push content below down
  }}
>
  {/* 1. Search Filter */}
  <Box > {/* flex: 1 allows it to take up the most space */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Search Filter
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "300px",
        height: "45px",
        backgroundColor: "#F4F7FE",
        borderRadius: "8px",
        padding: "0 16px",
        border: "1px solid transparent",
        transition: "all 0.2s ease",
        "&:focus-within": {
          border: "1px solid #4318ff", // Premium purple glow on focus
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
        },
      }}
    >
      <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
      <input
        value={filterInput}
        onChange={(e) => setFilterInput(e.target.value)}
        placeholder="Search Details..."
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          fontSize: "14px",
          color: "#2B3674",
          fontWeight: "500",
        }}
      />
    </Box>
  </Box>

  {/* 2. Project Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "250px" } }}> {/* Fixed width on desktop, 100% on mobile */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Project Name
    </Typography>
    <select
      required
      value={vPrname}
      onChange={(e) => setVPrname(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Project</option>
      {filteredProjects
        .filter((item) => item.company_id === parseInt(companyId))
        .map((item) => (
          <option key={item.ProjectName} value={item.ProjectName}>
            {item.ProjectName}
          </option>
        ))}
    </select>
  </Box>

  {/* 3. View Mode Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "200px" } }}> {/* Slightly smaller than Project dropdown */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      View Mode
    </Typography>
    <select
      value={viewMode}
      onChange={(e) => setViewMode(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="Full View">Full View</option>
      <option value="Customized View">Customized View</option>
    </select>
  </Box>
</Box>
</Box>
    
      {/* <div className="d-flex flex-row align-items-center">
        {viewMode === 'Customized View' && (
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              Select Columns
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ width: '800px', overflowX: 'auto' }}>
              <Container>
                <Row>
                  {selectedColumns.map((col, index) => (
                    <Col key={col.id} xs={6} md={4} lg={3}>
                      <Form.Check
                        type="checkbox"
                        id={`checkbox-${col.id}`}
                        label={col.label}
                        checked={selectedColumnIds.includes(col.id)}
                        onChange={() => handleColumnSelection(col.id)}
                      />
                    </Col>
                  ))}
                </Row>
              </Container>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div> */}

<div style={{ display: "flex", alignItems: "center" }}>
  {viewMode === 'Customized View' && (
    <Dropdown>
      {/* Premium Toggle Button */}
      <Dropdown.Toggle 
        id="dropdown-custom-components"
        style={{
          backgroundColor: "#F4F7FE",
          color: "#4318ff",
          border: "1px solid #E0E5F2",
          borderRadius: "8px",
          height: "45px",
          padding: "0 20px",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "none",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E9EDF7"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#F4F7FE"}
      >
        Select Columns
      </Dropdown.Toggle>

      {/* Responsive Dropdown Menu */}
      <Dropdown.Menu 
        style={{ 
          width: "600px",       // FIXED: Concrete width gives the grid room to breathe
          maxWidth: "85vw",     // FIXED: Prevents it from blowing past mobile phone screens
          minWidth: "300px",    
          maxHeight: "400px",   
          overflowY: "auto",    
          overflowX: "hidden",  
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #E0E5F2",
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.15)", // Stronger shadow so it floats
          marginTop: "10px",
          zIndex: 9999,         // FIXED: Forces the dropdown to render ON TOP of everything else
        }}
      >
        {/* Auto-flowing CSS Grid */}
        <div 
          style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", // Auto-fit ensures neat columns
            gap: "15px" 
          }}
        >
          {selectedColumns.map((col) => (
            <Form.Check
              key={col.id}
              type="checkbox"
              id={`checkbox-${col.id}`}
              label={col.label}
              checked={selectedColumnIds.includes(col.id)}
              onChange={() => handleColumnSelection(col.id)}
              style={{
                color: "#2B3674",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                margin: 0, 
                whiteSpace: "nowrap",    // Prevents checkbox text from wrapping awkwardly
                overflow: "hidden",      // Safely hides extra-long text
                textOverflow: "ellipsis" // Adds "..." if text is too long
              }}
            />
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )}
</div>

      {/* <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table" style={{ position: "relative", top: "1.3rem" }} id="table-to-xls">
          <TableHead sx={{ borderTop: "1px solid lightgray" }}>
            <TableRow>
              {selectedColumns.map((col, index) => (
                col.isVisible && (
                  <TableCell key={index} align="start" style={{ minWidth: col.width, fontSize: 14, fontWeight: "600" }}>
                    {col.label}
                  </TableCell>
                )
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {villaPlots
              .filter(row => selectedColumns.some(col => col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={index}>
                  {selectedColumns.map((col, idx) => (
                    col.isVisible && (
                      <TableCell key={idx} align="start" style={{ fontSize: 12, minWidth: col.width }}>
                        {row[col.id]}
                      </TableCell>
                    )
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <TableContainer 
  sx={{ 
    marginTop: "20px", // Replaces the absolute top: '1.3rem' hack
    borderRadius: "12px", 
    border: "1px solid #E0E5F2", 
    overflowX: "auto", // CRITICAL: Enables horizontal swiping on mobile
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 15px rgba(0,0,0,0.02)",
    // Custom slim scrollbar for a native app feel
    '&::-webkit-scrollbar': { height: '6px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
  }}
>
  <Table sx={{ minWidth: 800 }} stickyHeader aria-label="customized dynamic table" id="table-to-xls">
    
    <TableHead sx={{ background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)" }}>
      <TableRow sx={{ background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)" }}>
        {selectedColumns.map((col, index) => (
          col.isVisible && (
            <TableCell 
              key={index} 
              align="start" 
              sx={{ 
                minWidth: col.width || 120, // Fallback width if none provided
                color: "#fff", 
                  background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", // ✅ MOVE HERE
                fontWeight: "700", 
                fontSize: "13px", 
                padding: "16px",
                borderBottom: "1px solid #E0E5F2",
                whiteSpace: "nowrap" // Prevents headers from stacking vertically
              }}
            >
              {col.label}
            </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>

    <TableBody>
      {villaPlots
        .filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        )
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
          <TableRow hover key={index}>
            {selectedColumns.map((col, idx) => (
              col.isVisible && (
                <TableCell 
                  key={idx} 
                  align="start" 
                  sx={{ 
                    fontSize: "13px", 
                    fontWeight: idx === 0 ? "700" : "500", // Makes the first column bold for readability
                    color: idx === 0 ? "#2B3674" : "#707eae", // Darker primary text, softer secondary text
                    minWidth: col.width,
                    padding: "14px 16px",
                    borderBottom: "1px solid #E0E5F2"
                  }}
                >
                  {row[col.id] || "—"} {/* Adds a sleek dash if the data is empty */}
                </TableCell>
              )
            ))}
          </TableRow>
        ))}

        {/* Premium Empty State if filter returns nothing */}
        {villaPlots.filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        ).length === 0 && (
          <TableRow>
            <TableCell colSpan={selectedColumns.filter(c => c.isVisible).length} align="center" sx={{ padding: "40px" }}>
              <Typography sx={{ color: "#A3AED0", fontWeight: "600", fontSize: "14px" }}>
                No records found matching your filter.
              </Typography>
            </TableCell>
          </TableRow>
        )}
    </TableBody>

  </Table>
</TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={villaPlots
          .filter(row => selectedColumns.some(col => col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())))
          .length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <div className='d-flex flex-row align-items-center'>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename="tablexls"
          sheet="tablexls"
          buttonText="Excel"
          style={{ display: 'none' }} // Hide default button
        />

        <Button
          variant="contained"
          color="danger"
          size="large"
          style={{ marginLeft: '2rem', height: '50px' }}
          onClick={downloadPDF}
        >
          PDF
        </Button>
      </div>
    </>
  );
};

export default ProjectReport;
